import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IGetGrupoEconomicosQueryParams,
  IGrupoEconomico,
  IListaPaginada
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class GrupoEconomicoService {
  private readonly baseURL = '/GrupoEconomico';
  constructor(private httpClient: HttpClient) {}

  getGrupoEconomicos(body: IGetGrupoEconomicosQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IGrupoEconomico>>>(
      this.baseURL,
      body
    );
  }
}
